<template>
  <v-app-bar
    app
    dark
    color="primary"
  >
    <ScreenLoading :show="showLoading" />
    <v-app-bar-nav-icon
      v-if="user"
      @click="$emit('showSidebar')"
    />
    <v-toolbar-title>{{ pageName || routeName }}</v-toolbar-title>
    <v-spacer />
    <!--
    <v-col md="2">
      <v-select
        v-model="selectedLocale"
        :items="localeList"
        item-text="text"
        item-value="value"
        :label="$t('common.language')"
        prepend-icon="fa-globe"
        hide-details
      />
    </v-col>
    -->
    <v-col
      v-if="user"
      class="col-auto d-none d-sm-flex"
    >
      <v-icon>fa-user</v-icon> &nbsp;
      <span>{{ username }}</span>
    </v-col>
    <v-col
      v-if="user"
      class="col-auto link-pointer pa-0"
    >
      <v-btn
        icon
        :title="$t('common.logout')"
        @click="logout"
      >
        <v-icon>fa-sign-out-alt</v-icon>
      </v-btn>
    </v-col>
  </v-app-bar>
</template>

<script>
import ScreenLoading from '@/base/components/atoms/AtScreenLoading'

export default {
  components: {
    ScreenLoading
  },
  props: {
    user: {
      required: true,
      type: Boolean,
      default: false
    },
    pageName: {
      required: false,
      type: String,
      default: null
    }
  },
  data: function () {
    return {
      localeList: [
        { text: 'English', value: 'en' },
        { text: '繁體中文', value: 'zhHant' }
      ],
      locale: this.currentLocale,
      showLoading: false
    }
  },
  computed: {
    username () {
      return localStorage.getItem('username')
    },
    routeName () {
      return this.$route.name
    },
    selectedLocale: {
      get: function () {
        return this.currentLocale
      },
      set: function (value) {
        this.locale = value
        this.changeLocale(value)
      }
    }
  },
  methods: {
    logout () {
      this.showLoading = true
      return this.$store.dispatch('Auth/logout')
        .then(() => {
          this.showLoading = false
          this.$router.push({ name: 'Login' })
        })
        .catch(err => this.throwReject(err))
    }
  }
}
</script>
